import './Biographie.scss';

import portrait from './portrait.png';



const Biographie = () => {
  return(
    <article className='bio'>
      <p className='bio_title'> - Presentation - </p>

      <div className='bio_container'>

      <div className='bio_left'>
        <img src={portrait} alt='portrait de skinny en train de tatouer' className='bio_image'/>
      </div>

      <div className='bio_right'>
        <h2 className='bio_txt'>Bonjour,<br></br> je suis Elodie,<br></br> tatoueuse dans les environs de Marseille/Aix-en-Provence.</h2>


        <p className='bio_txt'>Diplômée dans le domaine de l'architecture, j'ai préféré lier ma passion du dessin à mon quotidien et je me suis naturellement orientée vers le tatouage. </p>
        <p className='bio_txt'>Mes inspirations et mon univers sont issus de l'amour du manga et la précision du réalisme.  </p>

        <p className='bio_txt'>Aujourd'hui, artiste tatoueuse,<br></br> je suis heureuse de vous accueillir dans mon salon pour donner vie à tous vos projets. </p>

        <p className='bio_txt'>N'hésitez pas à me contacter pour travailler ensemble et avec précision sur vos idées. </p>

        <p className='bio_txt'>A bientôt chez Skinny Tattoo.</p>
        

      </div>
      </div>
    </article>
  )
}

export default Biographie;